import styled from 'styled-components';

export default styled.div`
  display: flex;
  color: ${({ color }) => color};
  font-size: 14px;
  margin-bottom: 5px;
`;
